"use client";

import { useMemo, useSyncExternalStore } from "react";
import {
    CONSENT_CHANGE_EVENT,
    parseConsent,
    readConsentRaw,
} from "@/lib/cookieConsent";

function subscribe(onChange) {
    window.addEventListener(CONSENT_CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onChange);
}

/**
 * Le choix de cookies du visiteur, tenu à jour à chaque nouveau choix.
 *
 * `undefined` tant que le cookie n'a pas été lu (rendu serveur, hydratation),
 * `null` si le visiteur n'a encore rien décidé, sinon le choix.
 */
export default function useCookieConsent() {
    const raw = useSyncExternalStore(subscribe, readConsentRaw, () => undefined);
    return useMemo(() => (raw === undefined ? undefined : parseConsent(raw)), [raw]);
}
